(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bioclock-promo-bar"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bc-promo-bar'))customElements.define('bc-promo-bar',class extends HTMLElement{
 connectedCallback(){this.stop();this.abort?.abort();this.abort=new AbortController();this.current=0;this.messages=[...this.querySelectorAll('[data-message]')];this.show(0);document.addEventListener('visibilitychange',()=>this.start(),{signal:this.abort.signal});this.start();}
 show(index){this.current=index;this.messages.forEach((message,i)=>message.hidden=i!==index);}
 stop(){clearInterval(this.timer);}
 start(){this.stop();if(!document.hidden&&this.messages.length>1)this.timer=setInterval(()=>this.show((this.current+1)%this.messages.length),6000);}
 disconnectedCallback(){this.stop();this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bioclock-shop-directory"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bc-shop-directory')) customElements.define('bc-shop-directory',class extends HTMLElement{
  connectedCallback(){this.controller?.abort();this.controller=new AbortController();const input=this.querySelector('[data-shop-search]');if(!input)return;const normalize=t=>t.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');input.addEventListener('input',()=>{const query=normalize(input.value.trim());let count=0;this.querySelectorAll('[data-shop-group]').forEach(group=>{let shown=0;group.querySelectorAll('[data-shop-product]').forEach(card=>{card.hidden=!normalize(card.dataset.search||'').includes(query);if(!card.hidden){shown++;count++;}});group.hidden=shown===0;});this.querySelector('[data-shop-empty]').hidden=count>0;},{signal:this.controller.signal});}
  disconnectedCallback(){this.controller?.abort();}
});
if(!customElements.get('bc-routine-rotation'))customElements.define('bc-routine-rotation',class extends HTMLElement{
 connectedCallback(){this.controller?.abort();this.controller=new AbortController();this.slides=[...this.querySelectorAll('[data-routine-slide]')];if(!this.slides.length)return;this.index=Math.floor(Date.now()/8000)%this.slides.length;this.show();this.stop();this.timer=setInterval(()=>{if(document.hidden||this.matches(':hover')||this.contains(document.activeElement))return;this.index=(this.index+1)%this.slides.length;this.show();},8000);}
 show(){this.slides.forEach((slide,i)=>slide.hidden=i!==this.index);}
 stop(){clearInterval(this.timer);}
 disconnectedCallback(){this.stop();this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bioclock-shop-originale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-hero-motion')) {
    customElements.define('bc-hero-motion', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = new AbortController();
        const video = this.querySelector('video');
        if (!video) return;
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.abort.signal };
        let inView = !('IntersectionObserver' in window);
        let userPaused = false;
        let automaticPause = false;
        video.muted = true;
        const pause = () => {
          if (video.paused) return;
          // The pause event is asynchronous: do not mistake it for a user choice.
          automaticPause = true;
          video.pause();
        };
        const update = () => {
          if (!inView || document.hidden || preference.matches) pause();
          else if (!userPaused && video.paused) {
            video.play().catch(() => {});
          }
        };
        video.addEventListener('pause', () => {
          if (automaticPause) automaticPause = false;
          else userPaused = true;
        }, options);
        video.addEventListener('play', () => {
          userPaused = false;
          if (!inView || document.hidden || preference.matches) pause();
        }, options);
        preference.addEventListener('change', update, options);
        document.addEventListener('visibilitychange', update, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            inView = entry.isIntersecting && entry.intersectionRatio >= 0.1;
            update();
          }, { threshold: [0, 0.1] });
          this.observer.observe(this);
        }
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-product-film')) {
    customElements.define('bc-product-film', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.userControlled = false;
        this.inView = false;
        const syncPlayback = () => {
          if (document.hidden || !this.inView) this.video.pause();
          else if (!this.motion.matches && !this.userControlled) this.video.play().catch(() => {});
        };
        this.addEventListener('pointerdown', () => { this.userControlled = true; }, { signal: this.controller.signal });
        this.addEventListener('keydown', () => { this.userControlled = true; }, { signal: this.controller.signal });
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            this.inView = entry.isIntersecting && entry.intersectionRatio >= .25;
            syncPlayback();
          }
        }, { threshold: .25 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', syncPlayback, { signal: this.controller.signal });
        this.motion.addEventListener('change', event => { if (event.matches) this.video.pause(); }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.video?.pause(); }
    });
  }
  if (!customElements.get('bc-product-guide')) {
    customElements.define('bc-product-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        const headings = [...this.querySelectorAll('.bc-guide-heading')];
        const links = [...this.querySelectorAll('.bc-guide-link')];
        this.reveal = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.removeAttribute('data-guide-pending');
              this.reveal.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -32px 0px', threshold: 0.05 });
        if (!this.motion.matches) {
          this.querySelectorAll('.bc-guide-heading, .bc-text, details').forEach(node => {
            const rect = node.getBoundingClientRect();
            if (rect.top > innerHeight && rect.height < innerHeight * 2) {
              node.classList.add('bc-guide-reveal');
              node.setAttribute('data-guide-pending', '');
              this.reveal.observe(node);
            }
          });
        }
        this.motion.addEventListener('change', event => {
          if (event.matches) this.querySelectorAll('[data-guide-pending]').forEach(node => node.removeAttribute('data-guide-pending'));
        }, { signal: this.controller.signal });
        const update = () => {
          this.frame = null;
          const rect = this.getBoundingClientRect();
          const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (rect.height + innerHeight)));
          this.style.setProperty('--bc-guide-progress', progress.toFixed(3));
          let current = headings[0];
          for (const heading of headings) if (heading.getBoundingClientRect().top <= 180) current = heading;
          for (const link of links) {
            if (current && link.dataset.guideKind === current.dataset.guideKind) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          }
        };
        this.addEventListener('click', event => {
          const link = event.target.closest('.bc-guide-link');
          if (!link) return;
          const target = this.querySelector(link.hash);
          if (!target) return;
          event.preventDefault();
          target.removeAttribute('data-guide-pending');
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: this.motion.matches ? 'instant' : 'smooth', block: 'start' });
        }, { signal: this.controller.signal });
        window.addEventListener('scroll', () => {
          if (!this.frame) this.frame = requestAnimationFrame(update);
        }, { passive: true, signal: this.controller.signal });
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.reveal?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  if (!customElements.get('bc-magazine')) {
    customElements.define('bc-magazine', class extends HTMLElement {
      connectedCallback() {
        const nav = this.querySelector('.bc-magazine__contents');
        const content = this.querySelector('.blog-post-content');
        if (!nav || !content) return;
        const headings = [...content.querySelectorAll('h2')].filter(h => h.textContent.trim());
        nav.replaceChildren();
        nav.hidden = headings.length < 3;
        if (nav.hidden) return;
        const list = document.createDocumentFragment();
        headings.slice(0, 14).forEach((heading, index) => {
          heading.id ||= `${this.closest('[id]')?.id || 'magazine'}-section-${index + 1}`;
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          list.append(link);
        });
        nav.append(list);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  if (!customElements.get('bc-information-page')) {
    customElements.define('bc-information-page', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.bc-information-page__contents')) return;
        const feature = this.querySelector('.bc-information-page__feature');
        const title = this.querySelector('.text-block:has(h1)');
        if (feature && title) title.after(feature);
        const content = this.querySelector('.rte:not(:has(h1))');
        if (!content) return;
        const headings = [...content.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
        if (headings.length >= 3) {
          const lang = document.documentElement.lang.split('-')[0];
          const nav = document.createElement('nav');
          nav.className = 'bc-information-page__contents';
          nav.setAttribute('aria-label', ({it:'In questa pagina',en:'On this page',de:'Auf dieser Seite'})[lang] || 'On this page');
          headings.slice(0, 14).forEach((heading, index) => {
            if (!heading.id) heading.id = `bc-page-${this.closest('[id]')?.id || 'content'}-${index + 1}`;
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent.trim();
            nav.append(link);
          });
          content.before(nav);
        }
        content.querySelectorAll('table').forEach(table => {
          if (table.scrollWidth > table.clientWidth) table.tabIndex = 0;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
